import React from 'react';
import Icon from '../../../components/AppIcon';

const SeminarSection = () => {
  const cards = [
    {
      id: 1,
      title: "C",
      titles: "ourses",
      content: "Reverse learning-based short courses in AI, IoT, and Robotics",
      icon: "BookOpen",
      image: "/assets/images/courses.png",
    },
    {
      id: 2,
      title: "W",
      titles: "orkshops",
      content: "1-day to 5-day practical sessions held in colleges. Our workshops are designed for intense hands-on engagement.",
      icon: "Video",
      image: "/assets/images/workshop.png",
    },
    {
      id: 2,
      title: "S",
      titles: "eminars",
      content: "1-day expert seminars conducted in colleges. Our seminars are designed to provide insights, inspire ideas, and create awareness about emerging technologies.",
      //icon: "Video",
      image: "/assets/images/seminars.png",
    },
    {
      id: 3,
      title: "I",
      titles: "nternships",
      content: "Short-term project-based internship programs. College students get a chance to work on real-world problems under expert mentorship.",
      icon: "Briefcase",
      image: "/assets/images/internship.png",
    },
    {
      id: 4,
      title: "H",
      titles: "ackathons",
      content: "Themed innovation challenges with real rewards. We host problem-solving competitions that push creativity and engineering.",
      icon: "Zap",
      image: "/assets/images/hackathons.png",
    },
    
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-br from-background via-surface to-muted overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            <span className="text-nipix-blue">W</span>
            <span className="text-text-primary">hat </span>
            <span className="text-nipix-blue">N</span>
            <span className="text-text-primary">ipix </span>
            <span className="text-nipix-blue">P</span>
            <span className="text-text-primary">rovide</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
              Empowering Students with Future-Ready Skills
              At Nipix Technology, “From Courses to Innovators – We Build Creators, Not Just Learners.”</p>
        </div>

        {/* Cards Grid: 2 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card) => (
            <div
              key={card.id}
              className="relative rounded-2xl shadow-lg border border-border overflow-hidden bg-background cursor-pointer min-h-[300px] flex flex-col"
            >
              {/* Card Image */}
              <div
                className="relative flex items-center justify-center h-48 overflow-hidden bg-black"
                style={{
                  backgroundImage: `url(${card.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <div className="absolute inset-0 bg-black/40" />
                <div className="relative z-10 text-center text-white">
                  <div className="flex items-center justify-center mb-2">
                    {/*<span className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full">
                      <Icon name={card.icon} size={28} color="white" strokeWidth={2} />
                    </span>*/}
                  </div>
                  {/*<h3 className="text-2xl font-bold mb-1">{card.title}</h3>*/}
                </div>
              </div>

              {/* Card Content */}
              <div className="p-6 flex-grow">

                  <h3 className="text-2xl font-bold mb-1">
                    <span className="text-nipix-blue">{card.title}</span>
                    <span className="text-black">{card.titles}</span>
                  </h3>
                
                <p className="text-gray-700 text-sm leading-relaxed">{card.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SeminarSection;
